import { Component, OnInit, NgModule, ViewChild } from '@angular/core';
import { Insertnoticefollowup } from './insertnoticefollowup';
import { HttpClient, HttpRequest } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Injectable } from '@angular/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import * as _moment from 'moment';
import { Observable, of } from 'rxjs';
import { delay, map } from 'rxjs/operators';
import { stringify } from 'querystring';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { AppComponent } from '../../app.component';
import { AlertService } from '../../alertpopup/_alert';

declare var $: any;
export const MY_FORMATS = {
  parse: { dateInput: 'DD-MMM-YYYY' },
  display: {
    dateInput: 'DD-MMM-YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMM YYYY',
  },
};
export interface NoticePlanningStatus {
  id: string;
  ManagerID: string;
  LeaderID: string;
}
export interface NoticeCaseStatus {
  NoticeStatus: string;
  ConvertinCase: string;
  refno: string;
  ManagerID: string;
  LeaderID: string;
}
@Injectable({ providedIn: 'root' })



@Component({
  selector: 'app-add-followup',
  templateUrl: './add-followup.component.html',
  styleUrls: ['./add-followup.component.css'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
  standalone: false
})
export class AddFollowupComponent implements OnInit {
  url: string;
  FollowUpForm: FormGroup;
  id: any;
  numb: any;
  fileurls = [];
  dtColumns = [];
  fileSize: string;
  fileName: string;
  pageurl: string;
  contextID: any;
  ButtonCaption: string;
  FollowUpAction: any;
  fetchfollowupData: any;
  currentDate = new Date();
  CheckTargetDateFollowup: any;
  CheckRuleNPolicy: any;
  TargetDt: any;
  DateofDecision: any;
  FlowID: any;
  RuleNPolicyBackDate: string;
  FollowDate: string;
  editable: boolean;
  Type: any;
  HideButtonSubmit: string;
  NoticeCaseStatus: string;
  RightsID: string;
  RouteFollowUpAction: string;
  ActionTaken: string;
  HideRows: string;
  loading: boolean;
  Status: number;
  options = {
    autoClose: true,
    keepAfterRouteChange: false
  };
  // tslint:disable-next-line: max-line-length
  constructor(private router: Router, private http: HttpClient, private formBuilder: FormBuilder, private sanitization: DomSanitizer, public datepipe: DatePipe, protected alertService: AlertService) {
    this.url = AppComponent.baseURL;
  }

  ngOnInit() {
    this.loading = false;
    this.ActionTaken = "Action Taken";
    this.RightsID = localStorage.getItem('UserRight');
    if (this.RightsID.includes('202028001') || this.RightsID.includes('202028021') || this.RightsID.includes('202028000')) {
    } else {
      window.location.href = "module/0";
    }
    if (this.RightsID.includes('202042000') || this.RightsID.includes('202042001') || this.RightsID.includes('202042021')) {
      this.RouteFollowUpAction = "general-master/055";
    } else {
      this.RouteFollowUpAction = "module/0";
    }

    if (localStorage.getItem('Feedback') == "Feedback") {
      this.HideRows = "!isHidden";
      this.ActionTaken = "Feedback";
    } else {
      this.HideRows = "";
      this.ActionTaken = "Action Taken";
    }
    // 55 = Follow up action
    this.getMaster('055', '').subscribe((data: any) => {
      this.FollowUpAction = data;

    });

    this.GetRuleNPolicy();

    // Validation
    this.FollowUpForm = this.formBuilder.group({
      FollowDate: ['', Validators.required], ActionTaken: ['', Validators.required], followupFiles: [''], InTime: [''], OutTime: [''], ActionType: [null], AlertType: ['']
    });
    // Set By Default Value on Header Part
    this.FollowUpForm.patchValue({
      ActionType: null, AlertType: null
    });
    this.pageurl = this.router.url;
    let pagehead = this.pageurl.split('/');
    this.id = pagehead[2];
    this.contextID = pagehead[3];
    this.Type = pagehead[4];
    if (this.contextID > 0) {
      if (this.Type == 1) {
        this.http.get(this.url + 'CorporateDecision/Fetch_PlanningStatus_Convert?PlanningID=' + this.id)
          .subscribe((data) => {
            if (data == null) {
            } else {
              const noticePlanningStatus: NoticePlanningStatus = JSON.parse(data.toString())[0];
              if (localStorage.getItem('LoginUserID').toString() == noticePlanningStatus.ManagerID.toString()) {
                localStorage.setItem('Feedback', "");
              } else if (localStorage.getItem('LoginUserID').toString() == noticePlanningStatus.LeaderID.toString()) {
                localStorage.setItem('Feedback', "Feedback");
              } else {
                localStorage.setItem('Feedback', "");
              }
              if (localStorage.getItem('Feedback') == "Feedback") {
                this.HideRows = "!isHidden";
                this.ActionTaken = "Feedback";
              } else {
                this.HideRows = "";
                this.ActionTaken = "Action Taken";
              }
              if (noticePlanningStatus.id != "") {
                this.HideButtonSubmit = "!isHidden";
              }
            }
          }
          );
      }
      if (this.Type == 0 || this.Type == 2) {
        this.http.get(this.url + 'Notice/Fetch_Notice_Case_Status?id=' + this.id)
          .subscribe((data) => {
            if (data == null) {
            } else {
              const noticeCaseStatus: NoticeCaseStatus = JSON.parse(data.toString())[0];
              if (localStorage.getItem('LoginUserID').toString() == noticeCaseStatus.ManagerID.toString()) {
                localStorage.setItem('Feedback', "");
              } else if (localStorage.getItem('LoginUserID').toString() == noticeCaseStatus.LeaderID.toString()) {
                localStorage.setItem('Feedback', "Feedback");
              } else {
                localStorage.setItem('Feedback', "");
              }
              if (localStorage.getItem('Feedback') == "Feedback") {
                this.HideRows = "!isHidden";
                this.ActionTaken = "Feedback";
              } else {
                this.HideRows = "";
                this.ActionTaken = "Action Taken";
              }
              this.NoticeCaseStatus = noticeCaseStatus.NoticeStatus;
              if (this.NoticeCaseStatus == "1") {
                this.HideButtonSubmit = "!isHidden";
              }
            }
          }
          );
      }
    }
    if (this.contextID == "0") {
      this.ButtonCaption = "Add";
    } else {
      this.FetchFollowup();
      this.ButtonCaption = "Add";
    }
    this.http.get(this.url + 'CorporateDecision/Fetch_Existing_Notice_Planning?ID=' + this.id)
      .subscribe((data) => {
        if (data != null) {
          this.CheckTargetDateFollowup = JSON.parse(data.toString())[0];

          this.DateofDecision = this.CheckTargetDateFollowup.DateofDecision;
        }
      }
      );
  }

  get f() { return this.FollowUpForm.controls; }
  FetchFollowup() {
    // this.http.get(this.url + 'Notice/FetchFollowUP?NoticeID=' + this.id + '&FollowupID=' + this.contextID + '&type=' + this.Type)
    // .subscribe( (data) =>   {
    //     if (data == null) {
    //       this.fetchfollowupData = null;
    //     } else {
    //       const FetchNoticeFollowup: Insertnoticefollowup = JSON.parse(data.toString())[0];
    //       let latest_date = this.datepipe.transform(FetchNoticeFollowup.followNoticeDate, 'yyyy-MM-dd');
    //       this.FollowUpForm.patchValue({
    //         FollowDate: latest_date, ActionType: FetchNoticeFollowup.actionType , InHour: FetchNoticeFollowup.actionInTimeHr,
    //         InMin: FetchNoticeFollowup.actionInTimeMin, OutHour: FetchNoticeFollowup.actionOutTimeHr,
    //         OutMin: FetchNoticeFollowup.actionOutTimeMin ,
    //         AlertType: FetchNoticeFollowup.alertType, ActionTaken: FetchNoticeFollowup.actionTaken});
    //     }
    //    }
    // );
  }
  getMaster(GID: string, MID: string) {
    return this.http.get(this.url + 'GM/GetMaster?GenID=' + GID + '&MainID=' + MID)
      .pipe(map(data => data = (data == null ? null : JSON.parse(data.toString()))));
  }

  GetRuleNPolicy() {
    this.http.get(this.url + 'SysData/GetRuleNPolicy?GenID=250&MainID=1&SubId=2')
      .subscribe((data) => {
        if (data == null) {
          this.RuleNPolicyBackDate = "0";
        }
        else {
          this.FlowID = JSON.parse(data.toString())[0];
          this.RuleNPolicyBackDate = this.FlowID.RuleNPolicyBackDate;
        }
      }
      );
  }
  // For Get Fact Sheet Files in Base64 format
  onSelectFile(event) {
    this.fileurls = [];
    if (event.target.files && event.target.files[0]) {
      var filesAmount = event.target.files.length;
      this.fileName = '';
      this.fileSize = '';
      for (let i = 0; i < filesAmount; i++) {
        this.fileName += event.target.files[i].name + ',';
        this.fileSize += event.target.files[i].size + ',';
        let reader = new FileReader();
        reader.onload = (event: any) => { this.fileurls.push(event.target.result); };
        reader.readAsDataURL(event.target.files[i]);
      }
    }
  }


  FollowUpSubmit(FollowUpFormControl) {
    if (FollowUpFormControl.FollowDate == "") {
      this.alertService.showWarning("Please Select Date");
      return;
    }
    else if (this.datepipe.transform(FollowUpFormControl.FollowDate, "yyyy-MM-dd") > this.datepipe.transform(this.currentDate, "yyyy-MM-dd")) {
      this.alertService.showWarning("Please Selected Date is less than Current date ");
      return;
    }

    else if (FollowUpFormControl.ActionTaken == "") {
      this.alertService.showWarning("Please Enter " + this.ActionTaken);
    } else if (FollowUpFormControl.ActionType == null && this.ActionTaken == "Action Taken") {
      this.alertService.showWarning("Please Select Action Type");
    }
    else {
      if (this.FollowUpForm.invalid) { return; }
      this.loading = true;
      this.numb = 1;
      let InsertNoticeFollowup: Insertnoticefollowup = {
        id: this.contextID,
        fileSize: this.fileSize,
        fileBase: this.fileurls,
        fileName: this.fileName,
        followNoticeDate: FollowUpFormControl.FollowDate,
        actionTaken: FollowUpFormControl.ActionTaken,
        actionInTimeHr: FollowUpFormControl.InTime.split(':')[0],
        actionInTimeMin: FollowUpFormControl.InTime.split(':')[1],
        actionOutTimeHr: FollowUpFormControl.OutTime.split(':')[0],
        actionOutTimeMin: FollowUpFormControl.OutTime.split(':')[1],
        actionType: FollowUpFormControl.ActionType,
        alertType: FollowUpFormControl.AlertType,
        noticeID: this.id,
        recAddUser: this.numb,
        Type: this.Type
      };

      this.http.post(this.url + 'Notice/insertNoticeFollowUp', InsertNoticeFollowup).subscribe((data) => {
        this.loading = false;
        if (data == null) {
          this.alertService.showError("Followup Not Submitted");
        } else {
          if (this.contextID == "0") {
            this.alertService.showSuccess("Followup Submitted");
            this.FollowUpForm.reset();
          } else {
            this.alertService.showSuccess("Followup Updated");
          }
        }
      }
      );
    }
  }

  onFollowUpFormSubmit(FollowUpFormControl) {
    if (this.FollowUpForm.invalid) {
      this.FollowUpForm.markAllAsTouched();
      return;
    }
    this.http.get(this.url + 'CorporateDecision/Fetch_Existing_Notice_Planning?ID=' + this.id)
      .subscribe((data) => {

        if (data == null) {
          this.FollowUpSubmit(FollowUpFormControl);
        }
        else {
          this.CheckTargetDateFollowup = JSON.parse(data.toString())[0];
          this.DateofDecision = this.CheckTargetDateFollowup.DateofDecision;
          if (this.RuleNPolicyBackDate == "0") {
            if (this.datepipe.transform(FollowUpFormControl.FollowDate, "yyyy-MM-dd") > this.datepipe.transform(this.currentDate, "yyyy-MM-dd")) {
              this.alertService.showWarning("Please Selected Follow up  Date Only Current Date,because Back Date entry is not Allowed");
              return;
            }
            if (this.datepipe.transform(FollowUpFormControl.FollowDate, "yyyy-MM-dd") < this.datepipe.transform(this.currentDate, "yyyy-MM-dd")) {
              this.alertService.showWarning("Please Selected Follow up  Date Only Current Date,because Back Date entry is not Allowed");
              return;
            }
            this.FollowUpSubmit(FollowUpFormControl);
          }

          else if (this.RuleNPolicyBackDate == "1") {
            if (this.datepipe.transform(FollowUpFormControl.FollowDate, "yyyy-MM-dd") > this.datepipe.transform(this.currentDate, "yyyy-MM-dd")) {
              this.alertService.showWarning("Please Selected Follow up  Date Only Current Date or less than Date of Decision,because Back Date entry is  Allowed");
              return;
            }
            if (this.datepipe.transform(FollowUpFormControl.FollowDate, "yyyy-MM-dd") < this.datepipe.transform(this.DateofDecision, "yyyy-MM-dd")) {
              this.alertService.showWarning("Please Selected Follow up  Date Only Less Than current date or greater than Date of decision ,because Back Date entry is not Allowed");
              return;
            }
            this.FollowUpSubmit(FollowUpFormControl);
          }
          else {
            this.FollowUpSubmit(FollowUpFormControl);
          }
        }
      }
      );

  }
}
